export default (currency, tariff) => (currency && tariff?.cost_local?.hasOwnProperty(currency?.currency)
        ? tariff?.cost_local[currency?.currency || 'USD']
        : (tariff?.cost * (currency?.rate || 1)) || 0
);
